import React from 'react';
import {PopupPage, FullContainer} from 'components/container';
import store from 'utils/store'
import PremiumPlans from './premium_plans'

class PremiumModal extends React.Component {
  onBack(){
    store.dispatch({type:"CLOSE_PREMIUM_MODAL"})
  }
  render() {
    return (
      <PopupPage width="medium" backTo={this.onBack.bind(this)} title={"Go premium"}>
        <FullContainer noAnimation>
          <PremiumPlans backTo={this.onBack.bind(this)}/>
        </FullContainer>
      </PopupPage>
    );
  }
}

export default PremiumModal;



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/index.js